import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import {
    emailInvalidMessage,
    isRequiredMessage,
    phoneInvalidMessage,
    phoneNrPattern,
} from "../../common/validations";

const administratorInfoFormSchema = z.object({
    firstName: z.string().min(1, { message: isRequiredMessage }),
    lastName: z.string().min(1, { message: isRequiredMessage }),
    phone: z
        .string()
        .regex(phoneNrPattern, { message: phoneInvalidMessage })
        .min(1, { message: isRequiredMessage }),
    email: z.email({ error: emailInvalidMessage }),
    customerCreationAllowed: z.boolean(),
    municipalityRole: z.enum(["ADMIN", "ORDERER_ADMIN", "ORDERER"]),
});

export type AdministratorInfoFormData = z.infer<typeof administratorInfoFormSchema>;

export const useAdministratorInfoForm = () => {
    const form = useForm<AdministratorInfoFormData>({
        resolver: zodResolver(administratorInfoFormSchema),
        mode: "onChange",
        defaultValues: {
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            customerCreationAllowed: false,
            municipalityRole: "ADMIN",
        },
    });

    return form;
};
